import { useEffect } from 'react';

import {
	useAvailableSitesState,
	useIssueTypesState,
	useProjectsState,
} from '../providers/BulkConfigureContextProvider.tsx';
import { useBulkCreateContext } from '../providers/BulkCreateContextProvider.tsx';

import { useGetAvailableSites } from './useGetAvailableSites.tsx';
import { useGetJiraProjects } from './useGetJiraProjects.tsx';
import { useGetIssueTypes } from './useGetIssueTypes.tsx';
import { useGetMappedJiraWorkItemTypes } from './useGetMappedJiraWorkItemTypes.tsx';
import { useGetJiraParentCandidates } from './useGetJiraParentCandidates.tsx';
import { useGetJiraProjectComponents } from './useGetJiraProjectComponents.tsx';

export const useGetInitialDataForBulkIssueCreateForm = () => {
	useGetAvailableSites();
	const { selectedAvailableSite } = useAvailableSitesState();
	const [{ currentJiraSite }, { setCurrentJiraSite }] = useBulkCreateContext();
	// selectedAvailableSite is the "draft" site selected by the user from the site picker, whereas currentJiraSite is the "confirmed" site displayed on the panel
	// selectedAvailableSite and currentJiraSite are synced when the user saves the selection in configure view
	// The logic below just initializes currentJiraSite with the selectedAvailableSite if it is not already set
	useEffect(() => {
		if (selectedAvailableSite && !currentJiraSite) {
			void setCurrentJiraSite(selectedAvailableSite);
		}
	}, [selectedAvailableSite, currentJiraSite, setCurrentJiraSite]);

	useGetJiraProjects();
	const { selectedProject } = useProjectsState();
	const [{ currentJiraProject }, { setCurrentJiraProject }] = useBulkCreateContext();
	useEffect(() => {
		if (selectedProject && !currentJiraProject) {
			void setCurrentJiraProject(selectedProject);
		}
	}, [selectedProject, currentJiraProject, setCurrentJiraProject]);

	useGetIssueTypes();
	const { selectedIssueType } = useIssueTypesState();
	const [{ currentDefaultIssueType }, { setCurrentDefaultIssueType }] = useBulkCreateContext();
	useEffect(() => {
		if (selectedIssueType && !currentDefaultIssueType) {
			void setCurrentDefaultIssueType(selectedIssueType);
		}
	}, [selectedIssueType, currentDefaultIssueType, setCurrentDefaultIssueType]);
	useGetMappedJiraWorkItemTypes();
	useGetJiraParentCandidates();
	useGetJiraProjectComponents();
};
